export const autoAddress = (): void => {
  const postcodeEl = document.getElementById("postcode") as HTMLInputElement | null;
  const addressEl = document.getElementById("address") as HTMLInputElement | null;

  // 郵便番号 or 住所欄が見つからないページでは動かさない
  if (!postcodeEl || !addressEl) return;

  // 郵便番号入力欄のフォーカスが外れた時に実行
  postcodeEl.addEventListener("blur", () => {
    const raw = postcodeEl.value;
    const postcode = raw.replace(/-/g, "").trim(); // ハイフン除去 & トリム

    // 郵便番号は7桁でなければ検索しない
    if (!/^\d{7}$/.test(postcode)) return;

    // Zipcloud APIで住所取得
    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postcode}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.results || data.results.length === 0) {
          console.warn("住所が見つかりませんでした");
          return;
        }

        const result = data.results[0];
        const address = `${result.address1}${result.address2}${result.address3}`.trim();

        // 住所入力欄にセット
        addressEl.value = address;
      })
      .catch((error) => {
        console.error("郵便番号検索エラー:", error);
      });
  });
};
